import { Storage } from '@ionic/storage';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import moment from 'moment';

@Injectable()
export class PageBuilderValidation {

    constructor(
        public storage: Storage,
        public http: Http
    ) { }

    public pageValidation(widgets, values): Promise<any> {
        console.log('widgets', widgets);
        return new Promise((resolve) => {

            let responseTmp = { status: true, message: null };

            for (let i = 0; i < widgets.length; i++) {
                const widget = widgets[i];
                if (widget.validation) {
                    let value = values[widget.name];
                    for (var validationKey in widget.validation) {
                        let condition = widget.validation[validationKey];
                        switch (validationKey) {
                            case "isRequired": responseTmp = this.isRequired(widget.name, widget.label, condition, value); break;
                            case "minLength": responseTmp = this.minLength(widget.name, condition, value); break;
                            case "maxLength": responseTmp = this.maxLength(widget.name, condition, value); break;
                            case "minValue": responseTmp = this.minValue(widget.name, widget.label, condition, value); break;
                            case "maxValue": responseTmp = this.maxValue(widget.name, widget.label, condition, value); break;
                            case "isInRange": responseTmp = this.isInRange(widget.name, condition, value); break;
                            case "isEmail": responseTmp = this.isEmail(widget.name, condition, value); break;
                            case "isDateFormat": responseTmp = this.isDateFormat(widget.name, condition, value); break;
                            case "isDateInRange": responseTmp = this.isDateInRange(widget.name, condition, value, values); break;
                            case "isOnlyNumber": responseTmp = this.isOnlyNumber(widget.name, condition, value); break;
                            case "isOnlyAlphabet": responseTmp = this.isOnlyAlphabet(widget.name, condition, value); break;
                            case "isGreaterThan": responseTmp = this.isGreaterThan(widget.name, condition, value); break;
                            case "isGreaterThanEqual": responseTmp = this.isGreaterThanEqual(widget.name, condition, value); break;
                            case "isLessThan": responseTmp = this.isLessThan(widget.name, condition, value); break;
                            case "isLessThanEqual": responseTmp = this.isLessThanEqual(widget.name, condition, value); break;
                            case "isSpecialCharacter": responseTmp = this.isSpecialCharacter(widget.name, widget.label, condition, value); break;
                        }

                        if (responseTmp.status == false) {
                            break;
                        } else {

                        }
                    }
                }
                if (responseTmp.status == false) break;
            }

            resolve(responseTmp);

        })
    }

    private isRequired(key, label = null, condition, value) {
        if ((condition == true || condition == "true" || condition == 1 || condition == "1") && (value == null || value == undefined || value == "" || value == 0 || value == {} || value == [])) {
            let msg = (label) ? label : key;
            let res = {
                status: false,
                message: `"${msg}" is required!`
            };
            return (res);
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

    private minLength(key, condition, value) {

        let len = 0;

        if (value instanceof Array) {
            len = value.length;
        } else {
            value += "";
            len = value.length;
        }

        if (len < parseInt(condition)) {
            let res = {
                status: false,
                message: key + " minimum length is : " + condition
            };
            return (res);
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

    private maxLength(key, condition, value) {

        let len = 0;

        if (value instanceof Array) {
            len = value.length;
        } else {
            value += "";
            len = len = value.length;
        }

        if (len > parseInt(condition)) {
            let res = {
                status: false,
                message: key + " maximum length is : " + condition
            };
            return (res);
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

    private minValue(key, label = null, condition, value) {
        if (value.constructor.name == "Number") {
            if (value < parseInt(condition)) {
                let msg = (label) ? label : key;
                let res = {
                    status: false,
                    message: `"${msg}"  minimum value is : ${condition}`
                };
                return (res);
            } else {
                let res = { status: true, message: null };
                return (res);
            }
        } else {
            let res = {
                status: false,
                message: key + " is not number"
            };
            return (res);
        }
    }

    private maxValue(key, label = null, condition, value) {
        if (value.constructor.name == "Number") {
            if (value > parseInt(condition)) {
                let msg = (label) ? label : key;
                let res = {
                    status: false,
                    message: `"${msg}"  maximum value is : ${condition}`
                };
                return (res);
            } else {
                let res = { status: true, message: null };
                return (res);
            }
        } else {
            let res = {
                status: false,
                message: key + " is not number"
            };
            return (res);
        }
    }

    private isInRange(key, condition, value) {
        if (value.constructor.name == "Number") {
            if (value <= parseInt(condition.min) && value >= parseInt(condition.max)) {
                let res = {
                    status: false,
                    message: key + " is not in range"
                };
                return (res);
            } else {
                let res = { status: true, message: null };
                return (res);
            }
        } else {
            let res = {
                status: false,
                message: key + " is not number"
            };
            return (res);
        }
    }

    private isEmail(key, condition, value) {
        if (condition == true || condition == "true" || condition == 1 || condition == "1") {
            const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
            let check: boolean = expression.test(String(value).toLowerCase());
            if (!check) {
                let res = {
                    status: false,
                    message: key + " is not email"
                };
                return (res);
            } else {
                let res = { status: true, message: null };
                return (res);
            }
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

    private isDateFormat(key, condition, value) {
        let isValid = moment(value, condition.toUpperCase(), true).isValid();
        if (!isValid) {
            let res = {
                status: false,
                message: key + " is not date format : " + condition
            };
            return (res);
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

    private isDateInRange(key, condition, value, valueAlls?) {
        // console.log('TCL: DATE VALIDATION');
        // console.log(condition);
        // console.log(key);
        // console.log(value);
        // console.log(valueAlls);
        try {
            let startDate;
            let endDate;
            let date;

            if (condition.startDate === 'startDate' || condition.hasOwnProperty('rangeDateInValue') && condition.rangeDateInValue) {
                // console.log('Start Date Binding');

                startDate = valueAlls[condition.startDate];
                endDate = valueAlls[condition.endDate];
    
                if(startDate < endDate) {
                    let res = { status: true, message: null };
                    return (res);
                } else {
                    let res = {
                        status: false,
                        message: "End Date must be greater than Start Date"
                    };
                    return (res);
                }
            } else {
                startDate = new Date(condition.startDate).toISOString();
                endDate = new Date(condition.endDate).toISOString();
                date = new Date(value).toISOString();
    
                if(startDate <= date && date <= endDate) {
                    let res = { status: true, message: null };
                    return (res);
                } else {
                    let res = {
                        status: false,
                        message: key + " is not in range"
                    };
                    return (res);
                }
            }
        } catch (err) {
            let res = {
                status: false,
                message: "Invalid format date"
            };
            return (res);
        }
    }

    private isOnlyNumber(key, condition, value) {
        if (condition == true || condition == "true" || condition == 1 || condition == "1") {
            if(!isNaN(value)) {
                let res = { status: true, message: null };
                return (res);
            } else {
                let res = {
                    status: false,
                    message: key + " is not number"
                };
                return (res);
            }
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

    private isOnlyAlphabet(key, condition, value) {
        if (condition == true || condition == "true" || condition == 1 || condition == "1") {
            const expression = /^[A-Za-z]+$/;
            let check: boolean = expression.test(String(value).toLowerCase());
            if (!check) {
                let res = {
                    status: false,
                    message: key + " is not alphabet"
                };
                return (res);
            } else {
                let res = { status: true, message: null };
                return (res);
            }
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

    private isGreaterThan(key, condition, value) {
        let isOnlyNumber = this.isOnlyNumber(key, true, value);
        if (isOnlyNumber.status) {
            if (value > condition) {
                let res = { status: true, message: null };
                return (res);
            } else {
                let res = {
                    status: false,
                    message: key + " is not greater than " + condition
                };
                return (res);
            }
        } else {
            let res = {
                status: false,
                message: key + " is not number"
            };
            return (res);
        }
    }

    private isGreaterThanEqual(key, condition, value) {
        let isOnlyNumber = this.isOnlyNumber(key, true, value);
        if (isOnlyNumber.status) {
            if (value >= condition) {
                let res = { status: true, message: null };
                return (res);
            } else {
                let res = {
                    status: false,
                    message: key + " is not greater than equal " + condition
                };
                return (res);
            }
        } else {
            let res = {
                status: false,
                message: key + " is not number"
            };
            return (res);
        }
    }

    private isLessThan(key, condition, value) {
        let isOnlyNumber = this.isOnlyNumber(key, true, value);
        if (isOnlyNumber.status) {
            if (value < condition) {
                let res = { status: true, message: null };
                return (res);
            } else {
                let res = {
                    status: false,
                    message: key + " is not less than " + condition
                };
                return (res);
            }
        } else {
            let res = {
                status: false,
                message: key + " is not number"
            };
            return (res);
        }
    }

    private isLessThanEqual(key, condition, value) {
        let isOnlyNumber = this.isOnlyNumber(key, true, value);
        if (isOnlyNumber.status) {
            if (value <= condition) {
                let res = { status: true, message: null };
                return (res);
            } else {
                let res = {
                    status: false,
                    message: key + " is not less than equal " + condition
                };
                return (res);
            }
        } else {
            let res = {
                status: false,
                message: key + " is not number"
            };
            return (res);
        }
    }

    private isSpecialCharacter(key, label = null, condition, value) {
        let msg = (label) ? label : key;
        if (condition.length > 0) {
            let res = {
                status: true,
                message: null
            };
            let parseVal = String(value);
            let specialCharacter = '"';
            condition.forEach((item, index) => {
                specialCharacter += item;
                if (index != condition.length - 1) {
                    specialCharacter += ", ";
                }
            });
            specialCharacter += '"';
            for (let item of condition) {
                if (parseVal.indexOf(item) > -1) {
                    res['status'] = false;
                    res['message'] = msg + " cannot use character " + specialCharacter;
                    break;
                }
            }
            return (res);
        } else {
            let res = { status: true, message: null };
            return (res);
        }
    }

}


// WEBPACK FOOTER //
// ./src/pagebuilder/providers/validation/v1/validation.ts